import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePageURLContext} from "../../../contexts/pageURLContext";
import {requestContacts} from "../../../redux/Actions/contacts.actions";
import {
  getContactPaginationUrls,
  getContactsList,
  getContactTotalCount,
} from "../../../redux/Selectors/contacts.selectors";
import {generateNumericAwareQueryUrl} from "../../../helpers/generateNumericAwareQueryUrl";
import {useContactListurl} from "./contactsTable.constants";

export const useFetchContacts = () => {
  const {pageUrl} = usePageURLContext();
  const dispatch = useDispatch();

  const freshFetch = () => {
    dispatch(requestContacts());
  };

  const refetch = () => {
    dispatch(requestContacts(pageUrl));
  };

  return {refetch, freshFetch};
};

export const useContactTableData = () => {
  const dispatch = useDispatch();
  const contactListurl = useContactListurl();
  const {refetch, freshFetch} = useFetchContacts();
  const {setPageUrl} = usePageURLContext();
  const [currentPage, setCurrentPage] = useState(1);
  const contactsList = useSelector(getContactsList);
  const contactTotalCount = useSelector(getContactTotalCount);
  const contactUrls = useSelector(getContactPaginationUrls);

  useEffect(() => {
    freshFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAfterDelete = () => {
    if (contactsList.length === 1) {
      // If the last contact on the current page is deleted, reset to the first page
      setCurrentPage(1);
      setPageUrl("");
      freshFetch();
    } else {
      refetch();
    }
  };

  const handlePageChange = (page) => {
    const url = currentPage < page ? contactUrls?.nextUrl : contactUrls?.prevUrl;
    dispatch(requestContacts(url));
    setCurrentPage(page);
    setPageUrl(url);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  const handleSearch = (tokens) => {
    if (tokens?.length > 0) {
      const searchUrl = generateNumericAwareQueryUrl(contactListurl, tokens);
      dispatch(requestContacts(searchUrl));
      setPageUrl(searchUrl);
      setCurrentPage(1);
    } else {
      dispatch(requestContacts());
      setPageUrl("");
      setCurrentPage(1);
    }
  };

  return {
    contactsList,
    contactTotalCount,
    fetchAfterDelete,
    handleSearch,
    paginationConfig,
  };
};
